import { START_REQUEST, END_REQUEST } from "../actions/actionsTypes";

const loadingReducer = (state = [], action) => {
  switch (action.type) {
    case START_REQUEST: {
      return action.payload;
    }
    case END_REQUEST: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default loadingReducer;



// WEBPACK FOOTER //
// ./src/reducers/loading.js